import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as MemberFormActions from '../actions/member-form.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { MemberFormService } from '../../services/member-form.service';

@Injectable()
export class MemberFormEffects {
  private actions$ = inject(Actions);
  private service = inject(MemberFormService);


  SubmitMemberForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberFormActions.SubmitMemberForm),
      switchMap(({ memberForm: data }) =>
        this.service.submitMemberForm(data).pipe(
          map(memberForm => MemberFormActions.SubmitMemberFormSuccess({ memberForm })),
          catchError(error => of(MemberFormActions.SubmitMemberFormFail({ error })))
        )
      )
    );
  });
}
